// Components
import { graphql } from 'gatsby';
import React from 'react';

import Feed, { IFeedPostList } from '../components/feed';
import Layout from '../components/layout';
import { IPageInfo } from '../components/paginator';
import SEO from '../components/seo';

interface ITagPageTemplateProps {
  data: { posts: IFeedPostList };
  pageContext: {
    tag: string;
    pageInfo: IPageInfo;
  };
}

const Tags = ({
  data: { posts },
  pageContext: { tag, pageInfo }
}: ITagPageTemplateProps) => {
  const title = `Posts tagged with "${tag}"`;

  return (
    <Layout>
      <SEO title={title} defaultMetaTitle={true} />
      <Feed
        pageInfo={pageInfo}
        feedPostList={posts}
        bigFirst={false}
        header={title}
      />
    </Layout>
  );
};

export default Tags;

export const pageQuery = graphql`
  query($tag: String, $skip: Int, $limit: Int) {
    posts: allMarkdownRemark(
      sort: { fields: [frontmatter___date], order: DESC }
      filter: { frontmatter: { tags: { in: [$tag] } } }
      skip: $skip
      limit: $limit
    ) {
      ...FeedPostList
    }
  }
`;
